import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable max-len */
import { Button, Select } from '@outdoor-voices/ui';
import { useMutation } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { createImage } from './queries';
import { BRA_PRODUCT_TYPES, BRA_TOOLTIP, DT, EMAIL_TOOLTIP, ERRORS, FOOTWEAR_PRODUCT_TYPES, FOOTWEAR_TIPS, MAX_CHARS, MAX_CHARS_BRA, MIN_CHARS, MIN_CHARS_BRA, NO_FIT_PRODUCT_TYPES, NO_FIT_TIPS, STANDARD_TIPS, SUMMARY_TOOLTIP } from './constants';
import { FIT_RATINGS } from '../../config/constants-sizes';
import { validFileType, validFileSize } from './utils';
import errorHandler from '../../utils/errorHandler';
import RatingInput from '../RatingInput';
import Spinner from '../icons/Spinner';
import ToolTip from '../ToolTip';
import validEmail from '../../utils/strings/validEmail';
import css from './SubmitAReview.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Form = function Form(_ref) {
  var executeReview = _ref.executeReview,
      id = _ref.id,
      productType = _ref.productType,
      resReview = _ref.resReview,
      setSubmitted = _ref.setSubmitted,
      initialSizePurchased = _ref.sizePurchased,
      sizes = _ref.sizes;
  // Variables
  var CUSTOMER = window.OV.CUSTOMER; // Fit and Size

  var hasFit = !NO_FIT_PRODUCT_TYPES.includes(productType);
  var hasSize = !FOOTWEAR_PRODUCT_TYPES.includes(productType);

  var fitOptions = _toConsumableArray(Array(5).keys()).map(function (option) {
    return {
      label: FIT_RATINGS[option],
      value: String(option)
    };
  });

  var sizeOptions = sizes.map(function (size) {
    return {
      label: size,
      value: size
    };
  }); // Product Type

  var isAccessory = NO_FIT_PRODUCT_TYPES.includes(productType);
  var isBra = BRA_PRODUCT_TYPES.includes(productType);
  var isFootwear = FOOTWEAR_PRODUCT_TYPES.includes(productType);
  var reviewTips = [];

  if (isFootwear) {
    reviewTips = FOOTWEAR_TIPS;
  } else if (isAccessory) {
    reviewTips = NO_FIT_TIPS;
  } else {
    reviewTips = STANDARD_TIPS;
  } // State


  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      bra = _useState2[0],
      setBra = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      body = _useState4[0],
      setBody = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      charsTyped = _useState6[0],
      setCharsTyped = _useState6[1];

  var _useState7 = useState(CUSTOMER.loggedIn ? CUSTOMER.email : ''),
      _useState8 = _slicedToArray(_useState7, 2),
      email = _useState8[0],
      setEmail = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      fitRating = _useState10[0],
      setFitRating = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      heightFeet = _useState12[0],
      setHeightFeet = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      heightInches = _useState14[0],
      setHeightInches = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      imageError = _useState16[0],
      setImageError = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      reviewError = _useState18[0],
      setReviewError = _useState18[1];

  var _useState19 = useState(CUSTOMER.loggedIn ? CUSTOMER.name.split(' ')[0] : ''),
      _useState20 = _slicedToArray(_useState19, 2),
      name = _useState20[0],
      setName = _useState20[1];

  var _useState21 = useState(initialSizePurchased),
      _useState22 = _slicedToArray(_useState21, 2),
      sizePurchased = _useState22[0],
      setSizePurchased = _useState22[1];

  var _useState23 = useState(-1),
      _useState24 = _slicedToArray(_useState23, 2),
      rating = _useState24[0],
      setRating = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      submitting = _useState26[0],
      setSubmitting = _useState26[1];

  var _useState27 = useState(''),
      _useState28 = _slicedToArray(_useState27, 2),
      summary = _useState28[0],
      setSummary = _useState28[1];

  var _useState29 = useState(''),
      _useState30 = _slicedToArray(_useState29, 2),
      usualSize = _useState30[0],
      setUsualSize = _useState30[1];

  var _useMutation = useMutation(createImage),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      _useMutation2$ = _useMutation2[0],
      imageFetching = _useMutation2$.fetching,
      data = _useMutation2$.data,
      executeCreateImage = _useMutation2[1]; // Input


  var inputChangeMap = {
    bra: setBra,
    email: setEmail,
    fitRating: setFitRating,
    name: setName,
    summary: setSummary,
    heightFeet: setHeightFeet,
    heightInches: setHeightInches,
    sizePurchased: setSizePurchased,
    usualSize: setUsualSize
  }; // Check validity

  var _ref2 = data ? data.upload : false,
      image = _ref2.image;

  var sizeOS = sizes.indexOf('OS');
  var validSizeReview = sizeOS === -1 && sizes[sizeOS] !== 'OS';

  var isValid = function isValid() {
    var validFitRating = !imageFetching && !validSizeReview || fitRating !== '';
    var validReview = body.length >= MIN_CHARS && body.length <= MAX_CHARS;
    var optionalFitRating = fitRating ? validFitRating : true;
    var optionalUsualSize = usualSize ? usualSize != '' : true;
    return name !== '' && optionalFitRating && optionalUsualSize && rating > 0 && summary != '' && validReview && validEmail(email);
  }; // Functions


  var onInputChange = function onInputChange(event) {
    var target = event.target;
    var value = target.type === 'checkbox' ? target.checked : String(target.value);
    inputChangeMap[target.name](value);
  };

  var onSelectChange = function onSelectChange(_ref3) {
    var _ref3$target = _ref3.target,
        name = _ref3$target.name,
        value = _ref3$target.value;
    inputChangeMap[name](value);
  };

  var onBodyChange = function onBodyChange(event) {
    var value = event.target.value;
    var currBody = value.substring(0, MAX_CHARS);
    setBody(value);
    setCharsTyped(currBody.length);
  };

  var onImageChange = function onImageChange(_ref4) {
    var _ref4$target = _ref4.target,
        validity = _ref4$target.validity,
        files = _ref4$target.files;

    if (files.length < 1) {
      return;
    }

    var file = files[0];

    if (!validFileSize(file.size)) {
      setImageError(ERRORS.size);
      return;
    }

    if (!validFileType(file.type)) {
      setImageError(ERRORS.type);
      return;
    }

    if (!validity.valid) {
      setImageError(ERRORS.invalid);
      return;
    }

    setImageError(false);
    executeCreateImage({
      file: file,
      title: file.name
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var postBody, fetching, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              setImageError(false);
              setReviewError(false);

              if (isValid()) {
                _context.next = 6;
                break;
              }

              if (body.length < MIN_CHARS) {
                setReviewError("Reviews must be at least ".concat(MIN_CHARS, " characters long. Please add more to your review."));
              }

              return _context.abrupt("return");

            case 6:
              // eslint-disable-next-line
              postBody = {
                input: {
                  braSize: bra || null,
                  body: body,
                  email: email,
                  fitRating: fitRating || null,
                  heightFeet: heightFeet || null,
                  heightInches: heightInches || null,
                  image: image ? image.id : null,
                  name: name,
                  product: id,
                  rating: rating,
                  sizePurchased: sizePurchased || null,
                  summary: summary,
                  usualSizePurchased: usualSize || null
                }
              };
              setSubmitting(true);
              _context.next = 10;
              return executeReview(postBody);

            case 10:
              fetching = resReview.fetching, error = resReview.error;

              if (!fetching) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return");

            case 13:
              if (!error) {
                _context.next = 16;
                break;
              }

              errorHandler(error, 'submit-review');
              return _context.abrupt("return");

            case 16:
              setSubmitted(true);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref5.apply(this, arguments);
    };
  }(); // Return form


  return /*#__PURE__*/_jsxs("form", {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/_jsxs("fieldset", {
      className: cc([css.fieldset, css.reviewFieldset]),
      children: [/*#__PURE__*/_jsx("legend", {
        className: css.legend,
        children: "Your review"
      }), /*#__PURE__*/_jsx("span", {
        className: css.required,
        children: "*Required information"
      }), /*#__PURE__*/_jsxs("div", {
        className: css.fieldGroup,
        children: [/*#__PURE__*/_jsxs("label", {
          className: css.field,
          htmlFor: "name",
          children: [/*#__PURE__*/_jsx("div", {
            className: css.labelTextWrapper,
            children: /*#__PURE__*/_jsx("span", {
              className: css.labelText,
              children: "First name*"
            })
          }), /*#__PURE__*/_jsx("input", {
            autoComplete: "given-name",
            className: css.input,
            id: "name",
            name: "name",
            onChange: onInputChange,
            required: true,
            type: "text",
            value: name
          })]
        }), /*#__PURE__*/_jsxs("label", {
          className: css.field,
          htmlFor: "email",
          children: [/*#__PURE__*/_jsxs("div", {
            className: css.labelTextWrapper,
            children: [/*#__PURE__*/_jsx("span", {
              className: css.labelText,
              children: "Email used to purchase*"
            }), /*#__PURE__*/_jsx(ToolTip, {
              id: "email-tooltip",
              text: EMAIL_TOOLTIP
            })]
          }), /*#__PURE__*/_jsx("input", {
            "aria-describedby": "email-tooltip",
            autoComplete: "email",
            className: css.input,
            id: "email",
            name: "email",
            onChange: onInputChange,
            required: true,
            type: "email",
            value: email
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: css.fieldGroup,
        children: [/*#__PURE__*/_jsxs("div", {
          className: cc([css.rating, css.half]),
          children: [/*#__PURE__*/_jsx("div", {
            className: css.labelTextWrapper,
            children: /*#__PURE__*/_jsx("span", {
              className: css.labelText,
              children: "Overall rating:*"
            })
          }), /*#__PURE__*/_jsx(RatingInput, {
            onChange: function onChange(newRating) {
              return setRating(newRating);
            },
            value: rating,
            wide: true
          })]
        }), hasFit && /*#__PURE__*/_jsx("div", {
          className: cc([css.fit, css.half]),
          children: /*#__PURE__*/_jsx(Select, {
            id: "fit",
            itemDisabledLabel: 'Unavailable',
            label: "How did your product fit?*",
            name: "fitRating",
            onChange: function onChange(value) {
              return onSelectChange(value);
            },
            options: fitOptions,
            placeholder: "Select a fit",
            value: fitRating,
            required: true
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: css.fieldGroup,
        children: [/*#__PURE__*/_jsxs("label", {
          className: cc([css.summary, css.half]),
          htmlFor: "summary",
          children: [/*#__PURE__*/_jsxs("div", {
            className: css.labelTextWrapper,
            children: [/*#__PURE__*/_jsx("span", {
              className: css.labelText,
              children: "Review summary*"
            }), /*#__PURE__*/_jsx(ToolTip, {
              id: "summary-tooltip",
              text: SUMMARY_TOOLTIP
            })]
          }), /*#__PURE__*/_jsx("input", {
            "aria-describedby": "summary-tooltip",
            className: css.input,
            id: "summary",
            name: "summary",
            onChange: onInputChange,
            required: true,
            type: "text",
            value: summary
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: cc([css.spacer, css.half])
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: css.fieldGroup,
        children: /*#__PURE__*/_jsxs("label", {
          className: css.field,
          htmlFor: "review",
          children: [/*#__PURE__*/_jsx("div", {
            className: css.labelTextWrapper,
            children: /*#__PURE__*/_jsx("span", {
              className: css.labelText,
              children: "Review*"
            })
          }), /*#__PURE__*/_jsx("textarea", {
            className: css.textarea,
            id: "review",
            minLength: MIN_CHARS,
            maxLength: MAX_CHARS,
            name: "review",
            onChange: onBodyChange,
            required: true,
            rows: 10,
            value: body
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: css.reviewTips,
        children: [/*#__PURE__*/_jsxs("div", {
          className: css.tipsLabels,
          children: [/*#__PURE__*/_jsx("span", {
            className: css.tipsLabel,
            children: "Review tips:"
          }), /*#__PURE__*/_jsxs("span", {
            className: cc([css.tipsLabel, css.fieldTip]),
            children: [charsTyped, "/", MAX_CHARS, " characters"]
          })]
        }), /*#__PURE__*/_jsxs("ul", {
          className: css.tips,
          children: [reviewTips.map(function (tip, index) {
            return /*#__PURE__*/_jsx("li", {
              children: tip
            }, "tip-".concat(index));
          }), /*#__PURE__*/_jsxs("li", {
            children: ["".concat(MIN_CHARS, " character"), " minimum"]
          })]
        })]
      })]
    }), hasFit && hasSize && /*#__PURE__*/_jsxs("fieldset", {
      className: cc([css.fieldset, css.sizeFieldset, _defineProperty({}, css.full, !isBra)]),
      children: [/*#__PURE__*/_jsx("legend", {
        className: css.legend,
        children: "Size feedback"
      }), /*#__PURE__*/_jsx("span", {
        className: css.required,
        children: "*Required information"
      }), /*#__PURE__*/_jsxs("div", {
        className: cc([css.fieldGroup, css.feedbackFields, _defineProperty({}, css.vertical, isBra)]),
        children: [/*#__PURE__*/_jsx("div", {
          className: css.heightFields,
          children: /*#__PURE__*/_jsxs("div", {
            className: cc([css.fields, _defineProperty({}, css.mobileVertical, isBra)]),
            children: [/*#__PURE__*/_jsxs("div", {
              className: cc([css.heightWrapper, _defineProperty({}, css.full, !isBra), _defineProperty({}, css.half, isBra)]),
              children: [/*#__PURE__*/_jsxs("label", {
                className: css.field,
                htmlFor: "height-feet",
                children: [/*#__PURE__*/_jsx("div", {
                  className: css.labelTextWrapper,
                  children: /*#__PURE__*/_jsx("span", {
                    className: css.labelText,
                    children: "What\u2019s your height?*"
                  })
                }), /*#__PURE__*/_jsx("input", {
                  className: css.input,
                  id: "height-feet",
                  max: "8",
                  min: "1",
                  name: "heightFeet",
                  onChange: onInputChange,
                  placeholder: "Feet",
                  required: true,
                  type: "number",
                  value: heightFeet
                })]
              }), /*#__PURE__*/_jsx("label", {
                className: css.field,
                htmlFor: "height-in",
                children: /*#__PURE__*/_jsx("input", {
                  className: css.input,
                  id: "height-inches",
                  max: "11",
                  min: "0",
                  name: "heightInches",
                  onChange: onInputChange,
                  placeholder: "Inches",
                  required: true,
                  type: "number",
                  value: heightInches
                })
              })]
            }), isBra && /*#__PURE__*/_jsxs("label", {
              className: cc([css.bra, css.half]),
              htmlFor: "bra",
              children: [/*#__PURE__*/_jsxs("div", {
                className: css.labelTextWrapper,
                children: [/*#__PURE__*/_jsx("span", {
                  className: css.labelText,
                  children: "What\u2019s your bra size?*"
                }), /*#__PURE__*/_jsx(ToolTip, {
                  id: "bra-tooltip",
                  text: BRA_TOOLTIP
                })]
              }), /*#__PURE__*/_jsx("input", {
                className: css.input,
                id: "bra",
                maxLength: MAX_CHARS_BRA,
                minLength: MIN_CHARS_BRA,
                name: "bra",
                onChange: onInputChange,
                required: true,
                type: "text",
                value: bra
              })]
            })]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: css.sizeFields,
          children: [/*#__PURE__*/_jsx("div", {
            className: cc([css.usualSize, css.half]),
            children: /*#__PURE__*/_jsx(Select, {
              id: "usual-size",
              itemDisabledLabel: "Unavailable",
              label: "What\u2019s your usual size?*",
              name: "usualSize",
              onChange: function onChange(value) {
                return onSelectChange(value);
              },
              options: sizeOptions,
              placeholder: "Select a size",
              required: true,
              value: usualSize
            })
          }), /*#__PURE__*/_jsx("div", {
            className: cc([css.purchasedSize, css.half]),
            children: /*#__PURE__*/_jsx(Select, {
              id: "size-purchased",
              itemDisabledLabel: "Unavailable",
              label: "What size did you purchase?*",
              name: "sizePurchased",
              onChange: function onChange(value) {
                return onSelectChange(value);
              },
              options: sizeOptions,
              placeholder: "Select a size",
              value: sizePurchased,
              required: true
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs("fieldset", {
      className: cc([css.fieldset, css.imageFieldset]),
      children: [/*#__PURE__*/_jsx("legend", {
        className: css.legend,
        children: "Submit a photo"
      }), /*#__PURE__*/_jsx("span", {
        className: css.imageLabel,
        children: "Upload a jpg, jpeg, or png file (max 4MB)"
      }), /*#__PURE__*/_jsxs("div", {
        className: css.imageField,
        children: [image && /*#__PURE__*/_jsx("div", {
          className: css.fieldsetField,
          children: /*#__PURE__*/_jsx("img", _objectSpread({
            className: css.imagePreview,
            alt: image.alt
          }, image))
        }), imageFetching && /*#__PURE__*/_jsx("div", {
          className: css.spinner,
          children: /*#__PURE__*/_jsx(Spinner, {})
        }), /*#__PURE__*/_jsx("label", {
          htmlFor: "image",
          children: /*#__PURE__*/_jsxs("div", {
            className: css.imageUpload,
            children: [/*#__PURE__*/_jsx("span", {
              children: "+ Add photo"
            }), /*#__PURE__*/_jsx("input", {
              accept: ".jpg, .jpeg, .png",
              id: "image",
              name: "image",
              type: "file",
              onChange: onImageChange
            }), /*#__PURE__*/_jsx("div", {
              "aria-hidden": "true",
              className: css.imageUploadFocus
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          role: "status",
          children: imageError && /*#__PURE__*/_jsx("p", {
            className: cc([css.fieldHint, css.error]),
            children: "Could not upload image: ".concat(imageError, ".")
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("fieldset", {
      className: cc([css.fieldset, css.submitFieldset]),
      children: [/*#__PURE__*/_jsx("div", {
        role: "status",
        children: reviewError && /*#__PURE__*/_jsx("p", {
          className: cc([css.fieldHint, css.error]),
          children: reviewError
        })
      }), /*#__PURE__*/_jsx(Button, {
        big: true,
        className: css.submit,
        disabled: submitting,
        type: "submit",
        children: submitting ? DT : 'Submit Review'
      }), /*#__PURE__*/_jsx("p", {
        className: css.disclaimer,
        children: "By hitting \u201CSubmit Review\u201D you agree to our terms of use."
      }), /*#__PURE__*/_jsx("a", {
        className: css.actionLink,
        href: "/privacy-policy",
        rel: "noopener noreferrer",
        target: "_blank",
        children: "Privacy"
      }), /*#__PURE__*/_jsx("a", {
        className: css.actionLink,
        href: "/pages/contact-us",
        rel: "noopener noreferrer",
        target: "_blank",
        children: "Help"
      })]
    })]
  });
};

Form.defaultProps = {
  name: '',
  productName: '',
  productType: '',
  resReview: {
    fetching: true,
    error: false
  },
  sizes: ['']
};
Form.propTypes = {
  executeReview: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  productName: PropTypes.string,
  productType: PropTypes.string.isRequired,
  resReview: PropTypes.shape({
    fetching: PropTypes.bool,
    error: PropTypes.bool
  }),
  setSubmitted: PropTypes.func.isRequired,
  sizePurchased: PropTypes.string,
  sizes: PropTypes.arrayOf(PropTypes.string).isRequired
};
export default Form;